import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import Section from '../LandingSection';

import './LandingSellingPointsSection.scss';

const noop = () => {};

const LandingSellingPointsSection = ({
  title,
  description,
  subtitle,
  renderSubtitleIcon = noop,
  points,
  color = 'interaction'
}) => {
  return (
    <Section
      className={classNames(
        'selling-points__wrapper',
        `selling-points__wrapper--${color}`
      )}
      containerClassName="selling-points"
    >
      <div className="selling-points__title-container">
        <div className="selling-points__subtitle">
          {renderSubtitleIcon()}
          {subtitle}
        </div>
        <h2 className="selling-points__title">{title}</h2>
        <p>{description}</p>
      </div>
      <div className="selling-points__points-container">
        {points.map(({ titleKey, textKey, renderImage }) => (
          <div className="selling-points__point" key={titleKey}>
            {renderImage('selling-points__point__icon')}
            <div>
              <h3 className="selling-points__point__title">
                {trans(titleKey)}
              </h3>
              <p className="selling-points__point__text">{trans(textKey)}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

LandingSellingPointsSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  renderSubtitleIcon: PropTypes.func,
  points: PropTypes.arrayOf(
    PropTypes.shape({
      titleKey: PropTypes.string.isRequired,
      textKey: PropTypes.string.isRequired,
      renderImage: PropTypes.func.isRequired
    })
  ).isRequired,
  color: PropTypes.oneOf(['interaction', 'secondary-pink-light'])
};

export default LandingSellingPointsSection;
